import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

// زرار عائم على يمين الصفحة، بيظهر بعد ما المستخدم ينزل مسافة معينة، وبيرجعه لفوق بسلاسة
const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="الرجوع لأعلى الصفحة"
      className={`fixed bottom-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-[#F2B705] text-[#1B1B1F] shadow-lg shadow-[#F2B705]/40 transition-all duration-300 hover:bg-[#1B1B1F] hover:text-white hover:scale-105 active:scale-95 ${
        isVisible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
};

export default ScrollToTopButton;
